import {TypeFlightPlanning} from 'topmeteo/general/constants';

import Chunk from './Chunk';
import AutoLoadChunk from './AutoLoadChunk';

const Chunks = ({type, chunks, loaded, onLoad}) => {
    const Child = type === TypeFlightPlanning ? AutoLoadChunk : Chunk;

    return (
        <tr>
            {chunks.map(chunk => (
                <Child
                    {...chunk}
                    loaded={loaded[chunk.index]}
                    onLoad={onLoad}
                />
            ))}
        </tr>
    );
};

export default Chunks;
